export default __webpack_public_path__ + "static/0102-33a4448c098d52ea2c10f8a179579e14.png";